import React, { useState } from 'react';
import DistrictServices from '../../services/DistrictServices';

const CityStatus = ({city,page ,onSuccess}) => {

const [isChecked, setIsChecked] = useState(city?.status === 'Active');

  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Active' : 'Inactive';
    setIsChecked(!isChecked);
    if(page === 'Cities'){
      const res = await DistrictServices.updateCityStatus(city._id, {
        status: newStatus
      });
      onSuccess();
    }
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default CityStatus;
